export const I18n = {
    'en': {
        sure: 'Are you sure ?',
        delete: 'Delete',
        cancel: 'Cancel'
    },
    'ru': {
        sure: 'Вы уверены ?',
        delete: 'Удалить',
        cancel: 'Отменить'
    },
    'sk': {
        sure: 'Are you sure ?',
        delete: 'Delete',
        cancel: 'Cancel'
    }
};



// WEBPACK FOOTER //
// ./src/I18n/components/deleteModal/index.js